import CertificationNumber, {
  CertificationNumberLabel,
} from './CertificationNumber';
import CertificationExamFormat from './CertificationExamFormat';

export default function CertificationInfoWidget({
  info: {
    minimumApprovalLevel,
    examCompletionTimeLimit,
    numberOfExamQuestions,
    examQuestionFormats,
    linkToPracticeExam,
  },
}) {
  const hasMinimumApprovalLevel = minimumApprovalLevel !== null;
  const hasTimeLimit = examCompletionTimeLimit !== null;
  const hasNumberOfQuestions = numberOfExamQuestions !== null;
  const hasQuestionFormats = examQuestionFormats !== null;
  const hasPracticeExam = linkToPracticeExam !== null;

  return (
    <div className="flex flex-col rounded-xl bg-white shadow-xl">
      <h3 className="inline-flex items-center space-x-2 rounded-t-xl bg-gray-900 px-6 py-4 text-white">
        <div className="text-lg font-medium">Examen de certificación</div>
      </h3>
      <div className="divide-y-2 divide-gray-100">
        <div className="space-y-2 p-6">
          {hasMinimumApprovalLevel && (
            <CertificationNumber
              label="Nivel mínimo"
              value={`${minimumApprovalLevel}%`}
            />
          )}
          {hasTimeLimit && (
            <CertificationNumber
              label="Tiempo límite"
              value={`${examCompletionTimeLimit} minutos`}
            />
          )}
          {hasNumberOfQuestions && (
            <CertificationNumber
              label="Preguntas"
              value={numberOfExamQuestions}
            />
          )}
        </div>
        {hasQuestionFormats && (
          <div className="flex flex-col space-y-3 p-6">
            <CertificationNumberLabel
              label="Formatos de las preguntas"
              textColorClassName="text-gray-900"
              className="font-semibold"
            />
            <CertificationExamFormat formats={examQuestionFormats} />
          </div>
        )}
      </div>
      {hasPracticeExam && (
        <div className="flex w-full rounded-b-xl bg-gray-100 p-6">
          <a
            href={linkToPracticeExam}
            className="flex w-full items-center justify-center rounded-full bg-green-500 px-6 py-3 text-base font-semibold leading-none text-white hover:bg-green-600 focus:outline-none focus:ring-4 focus:ring-green-600 focus:ring-opacity-20 lg:py-2 lg:text-lg"
          >
            Realizar examen de práctica
          </a>
        </div>
      )}
    </div>
  );
}
